// Register the PWA service worker — but only in production.
// In development, aggressively unregister and clear any caches so the user
// sees live code changes immediately (CRA dev bundles aren't hashed, so a
// cache-first SW will mask edits).

const isProd = process.env.NODE_ENV === "production";

async function unregisterAndPurge() {
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if (typeof caches !== "undefined") {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("SW cleanup failed:", err);
  }
}

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  if (!isProd) {
    // Development: ensure nothing is intercepting requests.
    unregisterAndPurge();
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Pick up an updated worker as soon as it's available.
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              sw.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("Service worker registration failed:", err);
      });
  });
}
